export const sanitizeParams = (params: Record<string, any>) => {
    if (!params) return {};

    return Object.fromEntries(
        Object.entries(params).filter(([_, value]) => {
            if (value === null || value === undefined) return false;

            if (typeof value === 'string' && value.trim() === '') return false;

            if (Array.isArray(value)) {
                if (value.length === 0) return false;
                if (value.every((v) => v === undefined || v === null)) return false;
            }

            return true;
        })
    );
};
